module.exports = __webpack_public_path__ + "static/media/root_beer_hero.005e7746.jpg";